"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryTitle = void 0;
const getCountryTitle = (countryOptions, country) => {
    const countryObj = countryOptions && country && countryOptions.find((option) => +option.id === country);
    return countryObj ? countryObj.label : '';
};
exports.getCountryTitle = getCountryTitle;
